let isCartDrawerOpen = false;

function drawerOpen() {  
  const cartDrawer = document.getElementById('cartDrawer');
  const cartContent = document.getElementById('cartContent');
  const cartShadow = document.getElementById('cartShadow');
  const cartClosebtn = document.getElementById('cartDrawerCloseButton');

  document.documentElement.classList.add('js-drawer-open');
  
  // Set the drawer size based on screen width
  adjustCartDrawerSize();

  // Mark drawer as open
  isCartDrawerOpen = true;

  cartShadow.style.visibility = "visible";
  cartShadow.style.opacity = "1";

  // Wait until the drawer is open before showing content
  setTimeout(() => {
    cartContent.style.opacity = "1";
    cartClosebtn.style.opacity = "1";
    
  }, 300); // Delay to match the drawer's width transition
}

function drawerClose() {
  const cartDrawer = document.getElementById('cartDrawer');
  const cartContent = document.getElementById('cartContent');
  const cartShadow = document.getElementById('cartShadow');
  const cartClosebtn = document.getElementById('cartDrawerCloseButton');

  document.documentElement.classList.remove('js-drawer-open');

  // Hide the content before closing the drawer
  cartContent.style.opacity = "0";
  cartContent.style.opacity = "0";

  // Close the drawer after the content has hidden
  setTimeout(() => {
    if (window.innerWidth <= 749) {
      cartDrawer.style.width = "0";
    } else {
      cartDrawer.style.width = "0";
    }

    cartShadow.style.visibility = "hidden";
    cartShadow.style.opacity = "0";

    // Mark drawer as closed
    isDrawerOpen = false;
  }, 300);
}

function adjustCartDrawerSize() {
  const cartDrawer = document.getElementById('cartDrawer');

  if (window.innerWidth <= 749) {
    cartDrawer.style.height = "calc(100% - 12px)";  // Fixed height for mobile
    cartDrawer.style.width = "424px";
  } else {
    cartDrawer.style.width = "424px";   // Fixed width for desktop
    cartDrawer.style.height = "calc(100% - 12px)";
  }
}

// Add click event to open cart drawer
document.querySelector('.site-header__cart').addEventListener('click', function(e) {
  e.preventDefault();
  drawerOpen();
});

// Add click event to close cart drawer when overlay is clicked
document.querySelector('.cart-overlay').addEventListener('click', function(e) {
  e.preventDefault();
  drawerClose();
});






// Fetch cart HTML data via AJAX (Vanilla JS using fetch)
function carthtmldata() {
  fetch('/cart')
    .then(response => response.text())
    .then(cart_html => {
      const parser = new DOMParser();
      const cartDocument = parser.parseFromString(cart_html, 'text/html');
      
      const cartdrawer_content = cartDocument.querySelector('.cart-value').innerHTML;
      document.querySelector('.cart-value').innerHTML = cartdrawer_content;
      
      const cart_count = cartDocument.querySelector('#CartCount').innerHTML;
      document.querySelector('#CartCount').innerHTML = cart_count;
      
      const cartCount = cartDocument.querySelector('.cart-value .drawer__title').getAttribute('data-count');
      
      if (parseInt(cartCount) === 0) {
        document.querySelector('#CartCount').classList.add('hide');
      } else {
        document.querySelector('#CartCount').classList.remove('hide');
      }
      
      drawerOpen();
      document.querySelector('.cart__loading').classList.remove('ready');
    });
}

// Update quantity via POST request (Vanilla JS using fetch)
function qunatityChange(cart_item, cart_varid) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      "quantity": cart_item,
      "id": cart_varid,
    }),
  }).then(() => {
    carthtmldata();
  });
}



// Add item to cart using event delegation
document.addEventListener('click', function(event) {
  if (event.target.classList.contains('upsell-btn')) {
    document.querySelector('.cart__loading').classList.add('ready');

    const id = event.target.getAttribute('data-id');
    const data = {
      "quantity": 1,
      "id": id,
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }).then(() => {
      carthtmldata(); // Update cart data/UI after item is added
    });
  }
});


// Plus button click handler
function drawerPlus(item) {
  document.querySelector('.cart__loading').classList.add('ready');
  
  const cart_item = parseInt(item.previousElementSibling.value);
  const cart_varid = item.previousElementSibling.getAttribute('data-variantid');
  
  qunatityChange(cart_item + 1, cart_varid);
}

// Minus button click handler
function drawerMinus(item) {
  document.querySelector('.cart__loading').classList.add('ready');
  
  const cart_item = parseInt(item.nextElementSibling.value);
  const cart_varid = item.nextElementSibling.getAttribute('data-variantid');
  
  qunatityChange(cart_item - 1, cart_varid);
}

// Input change handler for direct quantity input
function drawerInputitem(item) {
  document.querySelector('.cart__loading').classList.add('ready');
  
  const cart_item = parseInt(item.value);
  const cart_varid = item.getAttribute('data-variantid');
  
  qunatityChange(cart_item, cart_varid);
}

// Remove item from cart
function drawerRemove(item) {
  document.querySelector('.cart__loading').classList.add('ready');
  
  qunatityChange(0, item.getAttribute('data-variantid'));
}

// Change variant for upsell items
function changeVariant(item) {
  const id = item.value;
  const price = item.querySelector(`option[value="${id}"]`).getAttribute('price');
  const img = item.querySelector(`option[value="${id}"]`).getAttribute('img');
  
  item.nextElementSibling.setAttribute('data-id', id);
  item.closest('.why-not-pro-list').querySelector('.pro-list-price').innerHTML = `<span>${price}</span>`;
  item.closest('.why-not-pro-list').querySelector('.pro-list-img img').src = img;
}

// Cart drawer functionality js =======end